import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('plant_capacity')
export class PlantCapacity {

  @PrimaryGeneratedColumn("increment",{name:'plant_capacity_id'})
  plantCapacityId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"plant_code"
      })
  // @Index({ unique: true })
  plantCode:string;
  @Column("varchar", {
    nullable: false,
    name: "operation",
  })
  operation: string;
  @Column({
    type:"decimal",precision:10,scale:2,
    name:"machine_capacity",
    default:0
    })
  machineCapacity:number;
  @Column({
   type:"decimal",precision:10,scale:2,
   name:"people_capacity",
   default:0
  })
  peopleCapacity:number;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  // @OneToMany(type => Destination, Destinations => Destinations.CountriesInfo)
  // DestinationsInfo: Destination[];
  

}
